module.exports = __webpack_public_path__ + "static/media/white-logo-vert.e0c2a0da.png";